import React from "react";
import ComparisonCards from "./ComparisonCards";

type ComparisonFeaturesDataType = {
  type: string;
  competitorLogo: string;
  features: {
    header: string;
    emoji: string;
    highlights: {
      icon: string;
      text: string;
      customWidth?: number;
    }[];
    graphyFeatures: string[];
    competitorFeatures: string[];
  }[];
};

interface ComparisonFeaturesProps {
  data: ComparisonFeaturesDataType;
}

const ComparisonFeatures: React.FC<ComparisonFeaturesProps> = ({ data }) => {
  return (
    <div className="container">
      {data?.features.map((feature, index) => {
        const isRight = Boolean(!(index % 2));
        return (
          <section
            key={index}
            id="comparison-features"
            className={`mb-20 flex gap-6 ${
              isRight ? "xl:flex-row" : "xl:flex-row-reverse"
            } flex-col items-center  xl:justify-center`}
          >
            <div
              className={`flex max-w-md flex-col justify-center gap-y-3 md:gap-y-8 flex-1 ${
                !isRight && ""
              } `}
            >
              <h2 className="text-title-32 text-grey-4">
                {feature.header}
              </h2>
              <div className={`flex flex-col`}>
                {feature?.highlights?.map((highlight) => (
                  <div
                    className="mb-6 flex items-center md:gap-3 xl:pr-10"
                    key={highlight.text}
                  >
                    <div style={{ minWidth: "57px" }}>
                      <img
                        src={highlight.icon}
                        width={highlight.customWidth || 24}
                        className="h-[24px] md:h-[40px]"
                        alt="highlight icon"
                      />
                    </div>
                    <p className="ml-1 text-grey-4 xl:w-96">
                      {highlight.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            
              <ComparisonCards
                competitorFeatures={feature.competitorFeatures}
                competitorLogo={data?.competitorLogo}
                graphyFeatures={feature.graphyFeatures}
                isRight={isRight}
                emoji={feature?.emoji}
              />
            
          </section>
        );
      })}
    </div>
  );
};
export default ComparisonFeatures;
